import { GetFragmentDto } from '@mi-front/core';
import type { QueryKey } from '@tanstack/query-core';
import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query/src/types';
import { apiClient } from '../../../../../../../../api';

export function useFragmentExternalExport(fragment: GetFragmentDto) {
  const query = useQuery({
    queryKey: ['fragment-export', fragment.id],
    queryFn: () => apiClient.fragments.fetch(fragment.id),
    enabled: !!fragment.externalExport,
    refetchInterval: (query) => {
      const data = query.state.data;

      const shouldRefresh =
        data?.media?.status === 'IN_PROGRESS' ||
        data?.externalExport?.status === 'WAITING_FOR_MEDIA' ||
        data?.externalExport?.status === 'IN_PROGRESS';

      return shouldRefresh ? 5000 : false;
    },
  }) as unknown as UseQueryResult<GetFragmentDto> & { queryKey: QueryKey };

  query.queryKey = ['fragment-export', fragment.id];

  return query;
}
